import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  pageContainer: {
    minHeight: "100vh",
    backgroundColor: "rgb(248, 249, 250)",
    paddingBottom: theme.spacing(3),
  },
  glossaryContainer: {
    padding: theme.spacing(3),
    maxWidth: 1078,
    width: "100%",
    margin: "0 auto",
    "@media print": {
      padding: 0,
    },
  },
  noPrint: {
    "@media print": {
      display: "none",
    },
  },
}));
